import './App.css';
import React, {useState, useEffect} from 'react';
import {BrowserRouter,Route, Routes,Navigate, Link} from 'react-router-dom';
import constants from './library/constants';
import Pulse from './components/common/Pulse';
import { useAuth } from "./auth/session";
import config from './config/apiConfig';

import NavBar from './parts/navigation/NavBar';
import Home from './views/Home';
import Login from './views/account/Login';
import AccountDetails from './views/account/AccountDetails'
import Transition from './views/transition/Transition';
import SolutionBuilder from './views/solutionBuilder/SolutionBuilder';
import MarketingContentBuilder from './views/marketingContentBuilder/MarketingContentBuilder';
import Checkout from './views/checkout/Checkout'
import ParkingCheckout from './views/checkout/ParkingCheckout'
import OffstreetParkingCheckout from './views/checkout/OffstreetParkingCheckout'
import CheckoutResult from './views/checkout/CheckoutResult';
import ShoppingCart from './views/shoppingCart/ShoppingCart';
import StandaloneTerminal from './views/terminal/StandaloneTerminal';
import OPT from './views/terminal/OPT';
import UnattendedSelf5000 from './views/terminal/UnattendedSelf5000';
import UnattendedPAXIM30 from './views/terminal/UnattendedPAXIM30';
import Agents from './views/Agents';
import PaymentDemo from './views/PaymentDemo';


function App() {
  const auth = useAuth();

  useEffect(() => {    
    if (auth.isAuthenticated) {
      localStorage.setItem(constants.storage.user, auth.user?.profile.email);      
    }
    const searchParams = new URLSearchParams(window.location.search);
    const questionParam = searchParams.get(constants.queryparams.question);
    const countryParam = searchParams.get(constants.queryparams.country)

    if (questionParam){
      localStorage.setItem(constants.localStorage.sharedquestion, questionParam);
    }

    if (countryParam){
      localStorage.setItem(constants.localStorage.countrypref, countryParam);
    }
        
  }, [auth.isAuthenticated]);

  const signOutRedirect = () => {
    const { clientId, logoutUri, cognitoDomain } = config.cognito;
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  if (auth.isLoading) {
    return <Transition message={<Pulse text="Loading....." />} />;
  }

  if (auth.error) {
    return (
      <Transition message={
        <>
      <div className='pb-2'>You'll need to login again ...</div>
      <button 
              onClick={() => auth.signinRedirect()}
              className="bg-gradient-to-r from-blue-700 to-blue-400 text-white px-3 py-2 rounded-md text-lg font-medium hover:from-blue-800 hover:to-blue-600 hover:text-white"
              
              >
              Log in
      </button>
      </>
      }/>
    )
  }

  return (
    <BrowserRouter>
    {/* ROLLBACK: Original was "bg-gradient-to-r from-sky-100 to-white" */}
    <div className="App min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <NavBar authenticated={auth.isAuthenticated}/>
      <div>     
      <Routes>
          {auth.isAuthenticated ?
          (
            <>
            <Route path="/" exact element={<Home />}></Route>          
            <Route path="/accountdetails" exact element={<AccountDetails/>}></Route>
            <Route path="/ask" exact element={<Home/>}></Route> 
            <Route path="/solutionbuilder" exact element={<SolutionBuilder />}></Route>
            <Route path="/marketingcontentbuilder" exact element={<MarketingContentBuilder />}></Route>
            <Route path="/shoppingcart" exact element={<ShoppingCart />}></Route>
            <Route path="/terminal" exact element={<StandaloneTerminal />}></Route>
            <Route path="/opt" exact element={<OPT />}></Route>
            <Route path="/unattendedself5000" exact element={<UnattendedSelf5000 />}></Route>
            <Route path="/unattendedpaxim30" exact element={<UnattendedPAXIM30 />}></Route>
            <Route path="/checkout" exact element={<Checkout />}></Route>
            <Route path="/parkingcheckout" exact element={<ParkingCheckout />}></Route>
            <Route path="/offstreetparkingcheckout" exact element={<OffstreetParkingCheckout />}></Route>
            <Route path="/checkoutresult" exact element={<CheckoutResult/>}></Route>
            <Route path="/agents" exact element={<Agents />}></Route>
            <Route path="/paymentdemo" exact element={<PaymentDemo />}></Route>
            </>
          )
          :
          (
            <>
            <Route path="/" exact  element={<Login />}></Route>        
            </>
          )
          }          
          <Route path="/logout" exact element={<Login />}></Route>          
          <Route path="/login" exact element={<Login />}></Route>                              
          <Route path="" element={<useNavigate to="/" />} />
        </Routes>
      </div>
    </div>
    </BrowserRouter>
  );
}

export default App;
